<template>
	<div class="downloadRemote">
		<Header @getHeaderHeight="getHeaderHeight"></Header>
		<div class="downloadRemote" :style="{ 'padding-top': headerHeight - 1 + 'px' }">
			<div class="spotlight-container">
				<div class="spotlight-content">
					<div class="spotlight-wrap">
						<div class="left">
							<div class="title">
								<img src="@/static/img/aurora-remote-icon.png" alt="logo">
							</div>
							<div class="introduction-text">{{ $t('dowmloadRemote.mainDesc')}}</div>
							<div class="download-wrap">
								<a href="javascript: void (0)" class="downloadBtn"
									@click="onDownload">{{ $t('dowmloadRemote.dowmload')}}</a>
								<div class="text">
									<span>*{{ $t('dowmloadRemote.text1')}}</span>
									<span class="important-explanation">{{ $t('dowmloadRemote.text2')}}</span>
									<span>{{ $t('dowmloadRemote.text3')}}</span>
								</div>
							</div>
						</div>
						<div class="right">
							<div class="media">
								<LazyImage className="viewport" imagePath="/res/img/icon-remote-header.png" ></LazyImage>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="download-content">
				<div class="content">
					<div class="content-title">
						<h1>{{ $t('dowmloadRemote.title')}}</h1>
						<h4>{{ $t('dowmloadRemote.secondary_title')}}</h4>
					</div>
					<div class="introduction-wrap">
						<div class="introduction-inner bg">
							<div class="introduction-item">
								<div class="left">
									<div class="title">
										<span class="txt">{{ $t('dowmloadRemote.quick_title')}}</span>
										<span>{{ $t('dowmloadRemote.quick_title_sec')}}</span>
									</div>
									<div class="introduction-text">
										{{ $t('dowmloadRemote.quick_open_txt') }}
									</div>
								</div>
								<div class="right">
									<LazyImage className="ml-vw" imagePath="/res/img/icon-illu-2.png" ></LazyImage>
								</div>
							</div>
						</div>
					</div>
					<div class="introduction-wrap">
						<div class="introduction-inner">
							<div class="introduction-item">
								<div class="left">
									<div class="title">
										<span>{{ $t('dowmloadRemote.file_title') }}</span>
										<span class="txt">{{ $t('dowmloadRemote.file_secondary_title') }}</span>
									</div>
									<div class="introduction-text">
										{{ $t('dowmloadRemote.file_txt') }}
									</div>
								</div>
								<div class="right">
									<LazyImage className="ml-vw" imagePath="/res/img/icon-illu-3.png" ></LazyImage>
								</div>
							</div>
						</div>
					</div>
					<div class="introduction-wrap">
						<div class="introduction-inner bg">
							<div class="introduction-item">
								<div class="left">
									<div class="title">
										<span class="txt">{{ $t('dowmloadRemote.media_title') }}</span>
										<span>{{ $t('dowmloadRemote.media_secondary_title') }}</span>
									</div>
									<div class="introduction-text">
										{{ $t('dowmloadRemote.media_txt') }}
									</div>
								</div>
								<div class="right">
									<LazyImage className="ml-vw" imagePath="/res/img/icon-illu-4.png" ></LazyImage>
								</div>
							</div>
						</div>
					</div>
					<div class="introduction-wrap">
						<div class="introduction-inner">
							<div class="introduction-item">
								<div class="left">
									<div class="title">
										<span class="txt">{{ $t('dowmloadRemote.search_title') }}</span>
										<span>{{ $t('dowmloadRemote.search_secondary_title') }}</span>
									</div>
									<div class="introduction-text">
										{{ $t('dowmloadRemote.search_txt') }}
									</div>
								</div>
								<div class="right">
									<LazyImage className="ml-vw" imagePath="/res/img/icon-illu-5.png" ></LazyImage>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	export default {
		name: 'downloadRemote',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				headerHeight: '',
				url: ''
			};
		},
		computed: {},
		methods: {
			getHeaderHeight(val) {
				this.headerHeight = val
			},
			onDownload() {
				const link = document.createElement('a')
				link.href = '/res/download/auroraremote.apk'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.downloadRemote {
		box-sizing: border-box;
	}
	.viewport {
		min-height: 650px;
	}
	.spotlight-container {
		background: linear-gradient( 180deg, #051412 0%, #051412 70%, #4F797C 100%);
		.spotlight-content {
			max-width: 1280px;
			margin: 0 auto;
			padding: 0 24px;
		}

		.spotlight-wrap {
			padding-top: 32px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				width: 50%;
				color: #fff;

				.title {
					font-size: 32px;
					font-family: 'Alibaba PuHuiTi B';
					img{
						max-width: 100%;
					}
				}

				.introduction-text {
					padding: 28px 0 24px;
					font-size: 18px;
				}

				.note {
					font-size: 14px;
					padding-bottom: 16px;
				}

				.txt {
					color: #0eae6d;
				}

				.download-wrap {
					.downloadBtn {
						display: inline-block;
						padding: 12px 20px;
						background: #1ef8a0;
						border-radius: 48px;
						color: #151515;
					}

					.text {
						padding-top: 14px;

						.important-explanation {
							color: #22b67b;
							font-size: 14px;
						}
					}
				}
			}

			.media {
				img {
					display: block;
					max-width: 100%;
					max-height: 100%;
					object-fit: contain;
					/* 或使用 'contain' 根据需求 */
				}
			}
		}
	}

	.content-title {
		max-width: 1280px;
		margin: 0 auto;
		width: 100%;
		padding: 48px 24px;

		h1,
		h4 {
			text-align: center;
			word-break: break-all;
		}

		h1 {
			font-size: 40px;
			font-family: 'Alibaba PuHuiTi B';
		}

		h4 {
			font-size: 20px;
			font-weight: 400;
		}
	}

	.introduction-wrap {
		.bg {
			background: #EDEDED;
		}

		.introduction-inner {
			padding-top: 40px;

			.left {
				width: 40%;
				color: #151515;

				.title {
					word-break: break-all;
					font-size: 32px;
					font-family: 'Alibaba PuHuiTi B';
				}

				.introduction-text {
					padding: 12px 0 16px;
					font-size: 18px;
				}

				.note {
					font-size: 14px;
					padding-bottom: 16px;
				}

				.txt {
					color: #0eae6d;
				}

				.download-wrap {
					.downloadBtn {
						display: inline-block;
						padding: 12px 20px;
						background: #1ef8a0;
						border-radius: 48px;
						color: #151515;
					}

					.text {
						padding-top: 14px;

						.important-explanation {
							color: #22b67b;
							font-size: 14px;
						}
					}
				}
			}
		}

		.introduction-item {
			padding: 0 24px;
			box-sizing: border-box;
			max-width: 1280px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;

			img {
				max-width: 100%;
				max-height: 100%;
			}
		}
	}

	@media (max-width: 768px) {
		.spotlight-wrap {
			flex-direction: column;

			.left {
				text-align: center;
				width: 100% !important;
			}
		}
		
		.viewport {
			min-height: 400px !important;
		}
		.ml-vw {
			min-height: 220px !important;
		}
		.introduction-item {
			flex-direction: column;
			margin: 24px 0;

			.left {
				text-align: center;
				width: 100% !important;
			}
		}
	}
</style>